import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

const Login: React.FC = () => {
  const [guestId, setGuestId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login({ guestId, password });
      navigate('/info');
    } catch (err) {
      setError('ID invité ou mot de passe invalide. Veuillez vérifier votre invitation.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1 className="login-title">Vous êtes invité(e) !</h1>
          <p className="login-subtitle">Veuillez entrer vos identifiants pour confirmer votre présence</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="guestId">ID Invité</label>
            <input
              id="guestId"
              type="text"
              value={guestId}
              onChange={(e) => setGuestId(e.target.value)}
              placeholder="ID à 4 chiffres sur l'invitation"
              maxLength={4}
              required
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Mot de passe</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Mot de passe à 6 caractères"
              maxLength={6}
              required
              className="form-input"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button 
            type="submit" 
            disabled={loading}
            className="submit-btn"
          >
            {loading ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

        <div className="login-info">
          <p>Vos identifiants sont composés d'un nombre à 4 chiffres et d'un mot de passe. Il vous a été envoyé par Facebook Messenger.</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
